import { getEventBySlug } from "@/lib/eventsData";
import { trpc } from "@/lib/trpc";

/** Shown when the title cannot be found. A slug is a URL fragment, never a heading. */
export const UNKNOWN_EVENT_TITLE = "this event";

/**
 * Picks the display title for an event slug: the built-in calendar first, then the
 * published events catalog. Returns undefined when neither knows the slug.
 */
export function pickEventTitle(slug: string, catalog: ReadonlyArray<{ slug: string; title: string }> | undefined): string | undefined {
  return getEventBySlug(slug)?.title ?? catalog?.find(event => event.slug === slug)?.title;
}

/**
 * The event's title for a tickets page. Events created in the admin are not in the
 * built-in calendar, so the title also comes from the public catalog; without that
 * the page used to fall back to the raw slug.
 */
export function useEventTitle(slug: string): string | undefined {
  const catalog = trpc.events.publicCatalog.useQuery(undefined, { enabled: Boolean(slug), retry: false });
  return pickEventTitle(slug, catalog.data as ReadonlyArray<{ slug: string; title: string }> | undefined);
}
